<template>
    <content-view>
        <div slot="header">
            <div>盘点日期：{{$route.query.inventoryTime}}</div>
            <div>盘点更新人：{{$route.query.inventoryUser}}</div>
        </div>
        <div class="stock-taking">
            <a-table
                bordered
                :dataSource="dataSource"
                :columns="columns"
                :pagination="false"
                :rowKey="record => record.serialNum"
            >
            </a-table>
        </div>
    </content-view>
</template>

<script type="text/javascript">
    import moment from 'moment';
    export default {
        name: 'stockTakingHistory',
        components: {},
        props: {},
        data() {
            const columns = [
                {
                    title: '商品编号',
                    dataIndex: 'serialNum'
                },
                {
                    title: '商品名称',
                    dataIndex: 'goodsName'
                },
                {
                    title: '商品类型',
                    dataIndex: 'goodsType'
                },
                {
                    title: '盘点前库存量',
                    dataIndex: 'beforeNum'
                },
                {
                    title: '盘点更新库存量',
                    dataIndex: 'afterNum'
                },
                {
                    title: '备注',
                    dataIndex: 'remark'
                }
            ];
            return {
                columns,
                dataSource: [],
                form: this.$form.createForm(this)
            };
        },
        computed: {},
        methods: {
            //获取页面信息筛选
            getList() {
                this.$api.storage
                .checkLogList({ body: {id: this.$route.query.id} })
                .then(res => {
                    this.dataSource = res
                });
            },
        },
        created() {},
        mounted() {
            this.getList()
        }
    };
</script>
<style lang="scss">
</style>